import React, { Component } from 'react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { connect } from 'react-redux'
import {withRouter} from 'react-router';
import { Button, Form, FormGroup, Label, Input, FormText, Col } from 'reactstrap';
import { updateFileData } from '../../../../actions/file';
import FileTypeMetaCategories from './FileTypeMetaCategories'
class FileMetaForm extends Component {

    constructor(props,context) {
        super(props,context);

        this.state = {
            file_type_id : false,
            file_product_id : '1',
            selectedAddress: '',
            is_priority: false
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.updateField = this.updateField.bind(this);
        this.mapFileTypes = this.mapFileTypes.bind(this);
        this.mapProducts = this.mapProducts.bind(this);
      
        this.handleChange = this.handleChange.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        this.props.updateFileData(this.props.clientPath.clientPath, JSON.stringify(this.state.file));
    }

    componentWillMount() {
        if(this.props.file) {
            this.setState({
                file: this.props.file,
                initialIsNotififiedState: this.props.file ? this.props.file.is_been_notified : 0
            })
        }

        if(this.props.match.params.addressId) {
            const addressId = this.props.match.params.addressId;

            const address = this.props.clientData.allAddresses.find(e => e.dp_address_id === addressId);

            this.setState({selectedAddress: address.dp_address_id});

            // -- create addresses array
            let addressOptions = [];
            const addresses = this.props.clientData.allAddresses;
            for(let key in addresses) {

                if(addresses[key]) {
                    if(addresses[key].client_id == address.client_id) {
                        let option = {
                                value: addresses[key]['dp_address_id'],
                                label: addresses[key]['street']+' '+addresses[key]['zipcode']+' '+addresses[key]['city']
                            }
                        addressOptions.push(option);                
                    }
                }
            } 
            this.setState({addressOptions: addressOptions});
        }
       
        if(this.props.is_priority) {
            this.setState({is_priority:true});
        }
    }

   

    mapFileTypes(filetype, key) {
        return (
            <option key={key} value={filetype.id}>{filetype.type}</option>
        )
    }

    mapProducts(product, key) {
        return (
            <option key={key} value={product.id}>{product.product_type}</option>
        )
    }

    updateField(e) {
        let value = false;

        if(e.target.value != 'NULL') {
            value = parseInt(e.target.value);
        }else{
            value = false;
        }
        this.setState({
            file: {
                ...this.state.file,
                [e.target.name] : value
            }

        })

     
        if(e.target.name == 'is_been_notified') {
            // -- pass it up
            this.props.setIsBeenNotified(e)
        }

        if(e.target.name == 'product_id') {
            // -- pass it up
            this.props.setProductId(e)
        }

        if(e.target.name == 'file_type_id') {
            // -- pass it up
            this.props.setFileType(e)
        }
        
        if(e.target.name == 'is_priority' || e.target.name == 'send_message') {
            // -- pass it up
            this.props.setMessageOption(e)
        }

    }
    handleChange(selectedOption) {
        this.props.setAddress(selectedOption);
        this.setState({ selectedAddress: selectedOption });
    }
    render() {
        
        return (
            <form action="" method="post" onSubmit={this.handleSubmit}>
                {!this.props.match.params.fileId ? 
                <FormGroup row>
                    <Label sm={3} for="product_id">Adres</Label>
                    <Col sm={9}>
                        {this.props.clientData.allAddresses  ?
                           <Select
                                name="address_id"
                                value={this.state.file && this.state.file.addresses ? this.state.file.addresses[0] ? this.state.file.addresses[0].value : this.state.selectedAddress : this.state.selectedAddress}
                                onChange={this.handleChange}
                                options={this.state.addressOptions ? this.state.addressOptions : []}
                              />
                          : ''}
                    </Col>
                </FormGroup> : '' }
                <FormGroup row>
                    <Label sm={3} for="product_id">Valt onder product</Label>
                    <Col sm={9}>
                        <Input type="select" onChange={(e) => this.updateField(e)} id="product_id" name="product_id" defaultValue={this.state.file ? this.state.file.product_id : 1}>
                            <option value="NULL">Selecteer een product</option>
                            {this.props.products.map((product, key) => this.mapProducts(product, key))}
                        </Input>
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label sm={3} for="file_type_id">Type</Label>
                    <Col sm={9}>
                        <Input type="select" onChange={(e) => this.updateField(e)} id="file_type_id" name="file_type_id" defaultValue={this.state.file ? this.state.file.file_type_id : ''}>
                            <option value="NULL">Selecteer een bestandstype</option>
                            { this.props.fileTypeData.data.map((filetype, key) => this.mapFileTypes(filetype, key))}
                        </Input>
                    </Col>
                </FormGroup>
                 <FormGroup row>
                    <Label sm={3} for="is_been_notified">Bericht versturen</Label>
                    <Col sm={9}>
                        <Input disabled={this.props.fileEdit && this.state.initialIsNotififiedState == '1' ? true : false} type="select" defaultValue="0" onChange={(e) => this.updateField(e)} id="is_been_notified" name="is_been_notified" defaultValue={this.state.file ? this.state.file.is_been_notified : ''}>
                            <option value="0">Nee</option>
                            <option value="1">Ja</option>
                        </Input>
                    </Col>
                </FormGroup>
               
                <FormGroup row>
                    <Label sm={3} for="message">Berichtopties</Label>
                    <Col sm={9}>
                          {/*<Label check>
                            <Input type="checkbox" onChange={(e) => this.updateField(e)} ref="send_message" id="send_message" name="send_message" defaultChecked='1' />{' '}
                            Bericht versturen
                          </Label>*/}
                          <Label check>
                            <Input disabled={this.props.fileEdit && this.state.initialIsNotififiedState == '1' ? true : false} type="checkbox" checked={this.props.fileEdit ? this.state.file.is_priority == "1" ? true : this.props.is_priority : this.props.is_priority} defaultValue={this.props.fileEdit ? this.state.file.is_priority == "1" ? "1" : this.props.is_priority : this.props.is_priority} defaultValue={this.props.is_priority} onChange={(e) => this.updateField(e)}  ref="is_priority" id="is_priority" name="is_priority" />{' '}
                            Is urgent?
                          </Label>
                    </Col>
                </FormGroup>                
           

                <div className="breakout">
                    {(this.state.file) && this.state.file.file_type_id ?   <FileTypeMetaCategories attachedValues={this.props.attachedValues} setTextValue={this.props.setTextValue} setCheckedValue={this.props.setCheckedValue} type_id={this.state.file.file_type_id} /> : null}
                </div>
            </form>
        )
    }
}


function mapStateToProps(state, ownProps) {

    return {
        clientData: state.ClientDataReducer,
        clientPath: state.clientPathReducer,
        products: state.ProductReducer.products,
        fileTypeData: state.FileTypeDataReducer,
        metaDataValueByCategory:state.FileMetaDataValueReducer.dataWithCategory
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateFileData: (url, data) => dispatch(updateFileData(url, data)),
    };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FileMetaForm))



// WEBPACK FOOTER //
// ./src/views/Files/Form/FileMetaForm/index.js